/* Public Klaviyo client API only. No private keys or automatic page-view subscriptions. */
(function () {
  'use strict';
  var offers = Object.freeze({dictionary: 'WdJHLd', secret_method: 'UDLRbK', seven_step: 'YntnMk'});
  function init(form) {
    if (form.dataset.drkBound) return;
    form.dataset.drkBound = 'true';
    var fieldset = form.querySelector('fieldset');
    var button = form.querySelector('button[type="submit"]');
    var status = form.querySelector('[role="status"]');
    var email = form.querySelector('[name="email"]');
    var first = form.querySelector('[name="first_name"]');
    var trap = form.querySelector('[name="website"]');
    var list = offers[form.dataset.drkLead];
    var busy = false, completed = false;
    function allowed() { return form.dataset.enabled === 'true' && list && !(window.Shopify && window.Shopify.designMode); }
    // Intercept even disabled/misconfigured forms, so personal data never enters a URL.
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (!allowed() || busy || completed) return;
      email.value = email.value.trim();
      if (!form.reportValidity()) return;
      if (trap.value.trim()) { status.textContent = 'Unable to submit. Please reload and try again.'; return; }
      busy = true;
      fieldset.disabled = true;
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      status.textContent = 'Submitting your signup…';
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 20000);
      var attributes = {
        email: email.value,
        subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}},
        properties: {
          drk_lead_last_source: 'shopify_' + form.dataset.drkLead,
          drk_lead_consent_version: 'lead-magnet-marketing-v1',
          drk_lead_consent_text: form.querySelector('.drk-lead-consent').textContent.trim()
        }
      };
      if (first.value.trim()) attributes.first_name = first.value.trim();
      attributes.properties['drk_lead_' + form.dataset.drkLead + '_requested'] = true;
      try {
        var response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=Xzk5uD', {
          method: 'POST', credentials: 'omit', signal: controller.signal,
          headers: {'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2026-07-15'},
          body: JSON.stringify({data: {type: 'subscription', attributes: {
            custom_source: 'Dr Knot — ' + form.dataset.drkLead + ' lead magnet',
            profile: {data: {type: 'profile', attributes: attributes}}
          }, relationships: {list: {data: {type: 'list', id: list}}}}})
        });
        if (response.status !== 202) throw new Error('request_not_accepted');
        completed = true;
        status.textContent = 'Thanks! Your signup request was accepted. Check your inbox, including spam, for next steps.';
      } catch (error) {
        status.textContent = error.name === 'AbortError'
          ? 'Confirmation is taking longer than expected. Your request may have been received. Check your inbox before trying again.'
          : 'We could not confirm your signup. Please check your connection and try again. If you already received an email, you do not need to submit again.';
      } finally {
        clearTimeout(timeout);
        busy = false;
        form.removeAttribute('aria-busy');
        fieldset.disabled = completed || !allowed();
        button.disabled = completed || !allowed();
      }
    });
    if (allowed() && window.fetch && window.AbortController) {
      fieldset.disabled = false;
      button.disabled = false;
      status.textContent = '';
    }
  }
  function mount() { document.querySelectorAll('form[data-drk-lead]').forEach(init); }
  mount();
  document.addEventListener('shopify:section:load', mount);
})();
